import ValidatedRecaptcha from './ValidatedRecaptcha';

export default ValidatedRecaptcha;
